import * as React from "react";
import { match, Redirect } from "react-router-dom";
import { buyStepRoute, dashboardRoute } from "../index";

type MatchProps = {
  organisationID?: string;
};

type Props = {
  match: match<MatchProps>;
};

const Trading = function (props: Props) {
  const { organisationID } = props.match.params;

  if (organisationID == null) {
    return <Redirect to={dashboardRoute()} />;
  }

  return <Redirect to={buyStepRoute(organisationID)} />;
};

export default Trading;
